<template>
  <el-table-column
    prop="user.last_name"
    label="Képviselő"
    show-overflow-tooltip
    min-width="170"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.user"
        style="display: inline-block;"
      >
        <el-link
          type="primary"
          @click="$router.push(`/users/view/${scope.row.user.id}`)"
        >
          {{ scope.row.user.last_name }} {{ scope.row.user.first_name }}
        </el-link>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'user.last_name',
};
</script>
